import { render, staticRenderFns } from "./StoreUserAdd.vue?vue&type=template&id=1bb8a070&scoped=true"
import script from "./StoreUserAdd.vue?vue&type=script&lang=js"
export * from "./StoreUserAdd.vue?vue&type=script&lang=js"
import style0 from "./StoreUserAdd.vue?vue&type=style&index=0&id=1bb8a070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb8a070",
  null
  
)

export default component.exports